import { render, staticRenderFns } from "./caigoufengxian.vue?vue&type=template&id=aa0fd43c&scoped=true"
import script from "./caigoufengxian.vue?vue&type=script&lang=js"
export * from "./caigoufengxian.vue?vue&type=script&lang=js"
import style0 from "./caigoufengxian.vue?vue&type=style&index=0&id=aa0fd43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0fd43c",
  null
  
)

export default component.exports